import { useEffect, useState } from 'react'
import { alertaGeneral } from '../../utils/alertas';
import { onHandleClickDownload } from '../ClinicComponent/TableDocuments';
import DocumentsInAppointments from './DocumentsInAppointments';
import apiClient from '../../utils/axiosPetition';
import SvgIcon from '../../utils/Icon';
import { ReactComponent as Documento } from '../../assets/icons/archivo.svg';
import PrescripcionDocumentsTable from './PrescripcionDocumentsTable';

const PatientDoctorDocumentsTable = ({ patientId = null, doctorId = null, isDownload = false, appoinmentActual = null, showAppointments = true, title = 'Documentos Médicos' }) => {
    const [documentos, setDocumentos] = useState(null);
    const [loadingDocs, setLoadingDocs] = useState(true);
    const [activeTab, setActiveTab] = useState('all_documents');

    const petitionAxios = patientId ? `/api/doctor/getDocumentsPatient/${patientId}` :
        doctorId ? `/api/doctor/getDocumentsAsigned/${doctorId}`
            : '';

    useEffect(() => {
        if (petitionAxios === '') {
            setLoadingDocs(false);
            return;
        }

        setLoadingDocs(true);
        apiClient.get(petitionAxios)
            .then((res) => {
                if (res) {
                    setDocumentos(res.data || {});
                }
            }).catch((error) => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: 'Hubo un problema al obtener los documentos del paciente. Por favor, inténtalo de nuevo.',
                    isError: true
                })
                console.error('Error al obtener los documentos del paciente:', error);
                setDocumentos({});
            }).finally(() => {
                setLoadingDocs(false);
            })

    }, [patientId, doctorId]);


    const onHandleClickView = (url) => {
        window.open(url, '_blank');
    }

    return (
        <div className="rounded-[1.75rem] md:rounded-[2rem] overflow-hidden shadow-[0_8px_30px_-8px_rgba(31,148,194,0.15),0_4px_16px_-6px_rgba(0,0,0,0.08)]">
            <h1 className="flex items-center text-white text-sm md:text-base font-medium bg-gradient-to-r from-[#1f94c2ff] to-[#1a7fa8] px-5 md:px-7 py-2.5 rounded-t-[1.75rem] md:rounded-t-[2rem]">
                <span className="flex items-center">
                    <SvgIcon Icon={Documento} className="w-5 h-5 mr-2.5 shrink-0" /> {title}
                </span>
            </h1>
            <div className="w-full py-4 md:py-6 px-4 md:px-6">
                {showAppointments && (
                    <div>
                        <nav className="flex rounded-xl overflow-hidden shadow-sm" aria-label="Tabs">
                            <button
                                onClick={() => setActiveTab('appointments')}
                                className={`flex-1 py-3 px-4 text-center font-semibold focus:outline-none text-sm transition-colors ${activeTab === 'appointments'
                                    ? 'bg-[#f79865ff] text-[#205087ff]'
                                    : 'bg-slate-200 text-slate-600 hover:bg-slate-300'
                                    }`}
                            >
                                Ver por citas
                            </button>
                            <button
                                onClick={() => setActiveTab('all_documents')}
                                className={`flex-1 py-3 px-4 text-center font-semibold focus:outline-none text-sm transition-colors ${activeTab === 'all_documents'
                                    ? 'bg-[#f79865ff] text-[#205087ff]'
                                    : 'bg-slate-200 text-slate-600 hover:bg-slate-300'
                                    }`}
                            >
                                Ver todos los documentos
                            </button>
                        </nav>
                        {activeTab === 'appointments' && showAppointments && (
                            <div className="overflow-x-auto max-w-full h-[400px] overflow-y mt-4">
                                <DocumentsInAppointments
                                    patientId={patientId && patientId}
                                    doctorId={doctorId && doctorId}
                                    appointmentActual={appoinmentActual && appoinmentActual}
                                    onHandleClickDownload={onHandleClickDownload}
                                    onHandleClickView={onHandleClickView}
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* INICIO DIFERENTES COMPONENTES */}
                {activeTab === 'all_documents' && (
                    <PrescripcionDocumentsTable
                        documentos={documentos}
                        loadingDocs={loadingDocs}
                        patientId={patientId}
                        isDownload={isDownload}
                        onHandleClickDownload={onHandleClickDownload}
                        onHandleClickView={onHandleClickView}
                    />
                )}

            </div>
        </div>
    )
}
export default PatientDoctorDocumentsTable;